import { Box } from "@chakra-ui/react";
import {
  ColorIcon,
  colors,
  cooKeys,
  customEvent,
  EventTriggerAndTargetType,
  GrayDropdown,
  GraySpinner,
  HStack,
  LargeButton,
  LARGEL_BUTTON_TYPE,
  setCookie,
  Spacing,
  Spinner,
  useResponsive,
  VStack,
} from "goi_common";

import React, { useCallback, useEffect, useMemo, useReducer, useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { isLoggedInState } from "@/atoms/accountState";
import { useDialog } from "@/hooks/useDialog";
import { getSangjoQuotationRequestExists, QuotationResponse } from "@/apis/sangjoQuotation";
// import { OverlayModal } from "goi_common";
import {
  장례준비긴급도_LIST,
  조문객예상인원_LIST,
} from "@/containers/MatchContainer/constants/request";
import { MatchRequestProps } from "@/containers/MatchContainer/type/requestType";
// import CustomRequestModalContent from "@/components/Match/CustomRequestModalContent";
import { matchRequestLoadingState } from "@/atoms/match/matchRequestLoadingState";
import { matchRequestResDataState } from "@/atoms/match/matchRequestResDataState";
import { temporaryMatchRequestState } from "@/containers/MatchContainer/atoms";
// import { useOverlay } from "@toss/use-overlay";
import QuotationExistContent from "./QuotationExistContent";
import { useRouter } from "next/router";
import { AxiosResponse } from "axios";
import useSangjoQuotationRequests from "@/hooks/useSangjoQuotationRequests";
import { useHandleSendMemoAndRedirectToLogin } from "@/containers/HomeContainer/hooks/useHandleSendMemoAndRedirectToLogin";
import { fireGuestSubmitEvents } from "@/containers/MatchContainer/fireGuestSubmitEvents";

const 긴급도_LIST = 장례준비긴급도_LIST.map((res) => ({ key: res, value: res }));
const 조문객_LIST = 조문객예상인원_LIST.map((res) => ({ key: res, value: res }));

export default function ParlorRequestBoxMayVersion({
  sido,
  sigungu,
  companyName,
}: {
  sido: any;
  sigungu: any;
  companyName: string;
}) {
  const { setResponsive } = useResponsive();

  const [SelectedOption, setSelectedOption] = useReducer(
    (prev: MatchRequestProps, next: any) => {
      return { ...prev, ...next };
    },
    {
      장례준비긴급도: "급하지 않지만 미리 알아보려고 해요.",
      sido: sido,
      sigungu: sigungu,
      조문객수: "100명 내외",
    },
  );

  const isLoggedIn = useRecoilValue(isLoggedInState);

  const { onOpen, onClose } = useDialog();

  const { setQuotationRequestCookie, mutateSangjoQuotation } = useSangjoQuotationRequests();

  const { handleSendMemoAndRedirectToLogin } = useHandleSendMemoAndRedirectToLogin();

  const isDisabled = useMemo(() => {
    return (
      !SelectedOption.장례준비긴급도 ||
      SelectedOption.sido === "0" ||
      !SelectedOption.sido ||
      !SelectedOption.sigungu ||
      !SelectedOption.조문객수
    );
  }, [SelectedOption]);
  const handleSubmit = useCallback(async () => {
    if (loading) return;

    customEvent({
      newGtm: {
        path: "parlor_detail",
        trigger_and_target: `submit_conversion` as EventTriggerAndTargetType["home"],
      },
    });

    if (isDisabled) {
      onOpen({
        type: 1,
        closeOnOverlayClick: false,
        header: "응답하지 않은 항목이 있어요",
        children: <>다시 확인해주세요.</>,
        footerProps: {
          text: "확인",
          onClick: onClose,
        },
      });

      return;
    }

    try {
      setLoading(true);

      const body = {
        status: SelectedOption.장례준비긴급도,
        funeral_sido: SelectedOption.sido,
        funeral_sigungu: SelectedOption.sigungu,
        needs_binso: SelectedOption.조문객수 === "0명(무빈소)" ? false : true,
        condolers:
          SelectedOption.조문객수 === "없음"
            ? ""
            : SelectedOption.조문객수 === "0명(무빈소)"
            ? "0명"
            : (SelectedOption.조문객수 as string),
      };

      const onSuccess = ({ data }: AxiosResponse<QuotationResponse>) => {
        customEvent({
          newGtm: {
            action: "match_request_complete",
          },
          triggerHackle: true,
        });
        // 기존 빠른폼 제출 성공 (parlor_detail 전용). #320 잠식 가드레일 - 무빈소/비교 카드와 분리 측정.
        customEvent({
          newGtm: {
            path: "parlor_detail",
            trigger_and_target: "quick_box-submit",
          },
        });
        fireGuestSubmitEvents(data?.status);

        setTemporaryMatchRequest(data.id);
        setResponseData(data);

        setQuotationRequestCookie(data);

        /*
         * 어느 장례식장 견적인지 로그인 화면에 남긴다.
         *
         * 이 폼은 여태 아무것도 남기지 않아서, 로그인 화면이 방문 이력(`previous`)에서
         * 장례식장을 추측해 왔다. 이력은 5칸까지만 남아 제출 후 다른 곳을 둘러보면
         * 엉뚱한 장례식장 비용이 나간다. 제출한 이 순간이 확실하므로 여기서 적는다.
         *
         * 평형은 이 폼이 묻지 않으므로 빈 값으로 덮어쓴다. 그래야 예전에 다른 장례식장에서
         * 고른 평형이 이번 견적에 따라붙지 않는다 (useCostLeadSubmit 과 같은 처리).
         */
        setCookie(
          cooKeys.parlor_request_info,
          JSON.stringify({ parlorName: companyName, 평형: "" }),
        );

        // overlay.open(({ isOpen, close: onClose }) => {
        //   return (
        //     <OverlayModal
        //       onClose={onClose}
        //       isOpen={isOpen}
        //       modalContentStyle={{
        //         minWidth: "320px",
        //         overflow: "scroll",
        //       }}
        //       overlayModalContent={
        //         <CustomRequestModalContent
        //           eventPath="parlor_detail"
        //           memo={`${companyName} 페이지에서 바로 제출한 견적`}
        //           onClose={onClose}
        //         />
        //       }
        //     />
        //   );
        // });

        handleSendMemoAndRedirectToLogin({
          path: "parlor_detail",
          memo: `${companyName} 페이지에서 바로 제출한 견적`,
        });

        setLoading(false);
      };

      mutateSangjoQuotation({
        body,
        onSuccess,
        onError: () => {
          setLoading(false);
        },
      });
    } catch (e: any) {
      setLoading(false);
    }
  }, [SelectedOption]);

  const [loading, setLoading] = useRecoilState(matchRequestLoadingState);
  const setResponseData = useSetRecoilState<any>(matchRequestResDataState);

  // const overlay = useOverlay();

  const [, setTemporaryMatchRequest] = useRecoilState(temporaryMatchRequestState);

  const [isQuotationExist, setIsQuotationExist] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isLoggedIn) {
      setIsLoading(true);
      getSangjoQuotationRequestExists()
        .then((quotation) => {
          setIsQuotationExist(quotation.request_exists);
          setIsLoading(false);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [isLoggedIn]);
  const router = useRouter();
  return (
    <VStack
      margin="16px 0"
      padding={"24px 12px"}
      alignItems="center"
      background="white"
      boxShadow="0px 0px 12px rgba(0, 0, 0, 0.12)"
      width={"100%"}
      css={{ minHeight: setResponsive("340px", "300px", "300px") }}
    >
      {isLoading ? (
        <VStack
          justifyContent="center"
          alignItems="center"
          width="100%"
          css={{ minHeight: setResponsive("340px", "300px", "300px") }}
        >
          <GraySpinner />
        </VStack>
      ) : (
        <>
          {isQuotationExist ? (
            <QuotationExistContent />
          ) : (
            <VStack width="100%">
              <div className={"subtitle_18_b gray900"}>
                {companyName} 예상비용
                <br />
                빠르게 알아보기
              </div>
              <Spacing gap={24} />
              <Box
                display="flex"
                gap="20px"
                width={"100%"}
                flexDir={"column"}
                alignItems={"initial"}
                justifyContent="center"
              >
                <VStack gap={8} width={"100%"}>
                  <HStack alignItems="center" gap={4}>
                    <ColorIcon name="icon-twinkle-circle-mono" color={colors.gray400} size="16px" />
                    <div className="body_14_m gray500">긴급도</div>
                  </HStack>
                  <VStack width="100%">
                    <GrayDropdown
                      name="긴급도"
                      values={긴급도_LIST}
                      value={SelectedOption.장례준비긴급도}
                      onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                        setSelectedOption({ 장례준비긴급도: e.target.value });
                        customEvent({
                          newGtm: {
                            path: "parlor_detail",
                            trigger_and_target:
                              `status-answer` as EventTriggerAndTargetType["home"],
                          },
                        });
                      }}
                    />
                  </VStack>
                </VStack>

                <Spacing gap={4} />
                <VStack gap={8} width="100%">
                  <HStack alignItems="center" gap={4}>
                    <ColorIcon name="icon-user-mono" color={colors.gray400} size="16px" />
                    <div className="body_14_m gray500">조문객 수</div>
                  </HStack>
                  <GrayDropdown
                    name="조문객 수"
                    values={조문객_LIST}
                    value={SelectedOption.조문객수}
                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      setSelectedOption({ 조문객수: e.target.value });
                      customEvent({
                        newGtm: {
                          path: "parlor_detail",
                          trigger_and_target:
                            `condolers-answer` as EventTriggerAndTargetType["home"],
                        },
                      });
                    }}
                  />
                </VStack>
                <VStack maxWidth={"100%"} width="100%" height="46px">
                  <LargeButton
                    className="button_14_sb"
                    buttonType={
                      isDisabled ? LARGEL_BUTTON_TYPE.DISABLED : LARGEL_BUTTON_TYPE.ORANGE_OUTLINED
                    }
                    disabled={isDisabled}
                    onClick={() => {
                      customEvent({
                        newGtm: {
                          path: "parlor_detail",
                          trigger_and_target: "uv_funeral_prepare_2",
                        },
                      });
                      router.push("/funeral-prepare/2/");
                    }}
                  >
                    {loading ? <Spinner /> : <>몇백만원을 줄이는 후불제상조 알아보기</>}
                  </LargeButton>
                </VStack>
                <VStack maxWidth={"100%"} width="100%" height="46px">
                  <LargeButton
                    className="button_14_sb"
                    buttonType={
                      isDisabled ? LARGEL_BUTTON_TYPE.DISABLED : LARGEL_BUTTON_TYPE.ORANGE
                    }
                    disabled={isDisabled}
                    onClick={handleSubmit}
                  >
                    {loading ? <Spinner /> : <>빠르게 알아보기</>}
                  </LargeButton>
                </VStack>
              </Box>
            </VStack>
          )}
        </>
      )}
    </VStack>
  );
}
